import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { PaymentStore } from '../service/payment.store';
import { Payment } from '../models/payment';

@Injectable()
export class PaymentsResolver implements Resolve<any> {
  constructor(
    private paymentStore: PaymentStore,
    private translateService: TranslateService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<Payment>> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];
    const allPayments: boolean = route.data['allPayments'];

    this.paymentStore.resetCalculatedPaymentWithTaxByEventPartyId();

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_ADJUSTMENTS'));
    }

    if (eventPartyId && !allPayments) {
      return this.paymentStore.loadPaymentsByParty(id, eventPartyId).first();
    } else {
      return this.paymentStore.loadPayments(id).first();
    }

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/payments.resolver.ts